/*
 *
 *  session sagas
 *
 */

import { call, take, put, all, delay } from "redux-saga/effects"
import { setAuthToken } from "../../helpers/index"

import store2 from "store2"
import {
  VERIFY_SESSION,
  LOG_IN,
  LOG_OUT,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  OTP_APPROVE,
} from "./constants"

import {
  verifySessionSuccess,
  verifySessionError,
  logInSuccess,
  logInError,
  logOutSuccess,
  logOutError,
  forgotPasswordSuccess,
  forgotPasswordError,
  resetPasswordSuccess,
  resetPasswordError,
  otpApproveSuccess,
  otpApproveError,
} from "./actions"

import {
  verifySession,
  logIn,
  forgotPassword,
  resetPasswordAPI,
  otpApproveAPI,
} from "./remotes"

// const machineId = localStorage.getItem("MachineId")
// console.log(machineId, "machineId from api")
export function* verifyInitialSessionSaga() {
  const secret = store2.get("secret")
  const location = (window.location && window.location.pathname) || "/"

  if (secret && !["/reset-password/"].includes(location)) {
    try {
      setAuthToken(secret)
      store2.set("secret", secret)
      const user = yield call(verifySession)
      yield put(verifySessionSuccess(user))
    } catch (error) {
      store2.remove("secret")
      store2.remove("authUser")
      window.location.reload()
    }
  } else {
    try {
      yield put(logOutSuccess())
    } catch (error) {
      yield put(logOutError(error))
    } finally {
      store2.remove("secret")
      store2.remove("authUser")
    }
  }
}

export function* verifySessionSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { secret } = yield take(VERIFY_SESSION)
    if (secret && !process.env.offline) {
      try {
        setAuthToken(secret)
        const user = yield call(verifySession)
        yield put(verifySessionSuccess(user))
      } catch (error) {
        yield put(verifySessionError("Session Expired!"))
      }
    }
  }
}

export function* loginSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { user, history, setSubmitting } = yield take(LOG_IN)

    try {
      yield call(setSubmitting, true)

      const response = yield call(logIn, user)
      setAuthToken(
        response && response.sessionInfo && response.sessionInfo.token
      )
      yield delay(500)
      console.log(response.menu,"my own res")
      localStorage.setItem("secret", response.sessionInfo.token)
      localStorage.setItem("authUser", JSON.stringify(response))
      localStorage.setItem("empId", response.id)
      localStorage.setItem("loginDevice", response.deviceId)
      localStorage.setItem("menu", JSON.stringify(response.menu))
     
      yield put(logInSuccess(response))
      
      // if (machineId !== loginDeviceId) {
      //   history.push("/otp-approve")
      // } else {
        history.push("/dashboard")
      // }
    } catch (error) {
      localStorage.setItem("error", error)
      yield put(
        logInError(
          (error && error.message) ||
            (error && typeof error === "string" && error) ||
            JSON.stringify(error)
        )
      )
    } finally {
      yield call(setSubmitting, false)
    }
  }
}

function* logOutSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { history } = yield take(LOG_OUT)

    try {
      yield put(logOutSuccess())
      history.push("/login")
      localStorage.setItem("menu","")
    } catch (error) {
      yield put(logOutError(error))
    } finally {
      store2.remove("authUser")
      store2.remove("secret")
    }
  }
}

export function* forgotPasswordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { record } = yield take(FORGOT_PASSWORD)

    try {
      const result = yield call(forgotPassword, record)
      if (result) {
        yield put(forgotPasswordSuccess(result.message))
      } else {
        yield put(forgotPasswordError("Unable to send email"))
      }
    } catch (error) {
      yield put(forgotPasswordError("Unable to send email"))
    }
  }
}
//RESET PASSWORD
export function* resetPasswordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { reset_Password } = yield take(RESET_PASSWORD)
    console.log(reset_Password, "inside saga")
    try {
      const result = yield call(resetPasswordAPI, reset_Password)
      console.log(result, "api result")
      if (result) {
        yield put(resetPasswordSuccess(result.message))
      } else {
        yield put(resetPasswordError("Reset password record failed"))
      }
    } catch (error) {
      yield put(resetPasswordError("Reset password record failed"))
    }
  }
}
//OTP APprove
export function* otpApproveSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { otp_approve } = yield take(OTP_APPROVE)
    console.log(otp_approve, "inside saga")
    try {
      const result = yield call(otpApproveAPI, otp_approve)
      console.log(result, "api result")
      if (result) {
        yield put(otpApproveSuccess(result.message))
      } else {
        yield put(otpApproveError("Otp Approve failed"))
      }
    } catch (error) {
      yield put(otpApproveError("Otp Approve failed"))
    }
  }
}
//reset password

export default function* rootSaga() {
  yield all([
    verifyInitialSessionSaga(),
    verifySessionSaga(),
    loginSaga(),
    logOutSaga(),
    forgotPasswordSaga(),
    resetPasswordSaga(),
    otpApproveSaga(),
  ])
}
